import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams, useNavigate } from 'react-router-dom';

import SubAbasGlossario from './subabasGlossario';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import SubAbas from '../../../../components/SubAbas';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { useTipoTermoGlossario } from '../../../../services/enum/useTipoTermoGlossario';
import { getGlossario } from '../../../../services/home/glossarioService';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import { formataNomeMeioSiglas } from '../../../../utils/functions';
import {
  swal,
  swalAtualizacao,
  swalSave,
  swalErro,
  swalDelete,
  swalDeleteConfirm,
} from '../../../../utils/swal';

//Dados do usuário
const user = getUser();
const userID = user.sub;

export default function GlossarioFicha() {
  const navigate = useNavigate();
  const params = useParams();
  const fichaID = String(params.id);
  const tipoTermo = useTipoTermoGlossario();

  //Dados do componente
  let logs = {};
  let subAbas = [];

  const [logData, setLogData] = useState({
    id: '',
    usuarioRegistro: {
      nomeCompleto: '',
    },
    usuarioAtualizacao: {
      nomeCompleto: '',
    },
    dataRegistro: '',
    dataUltimaAtualizacao: '',
    dataUltimaVisualizacao: '',
    nEdicoes: '',
    nVisualizacoes: '',
    nVisualizadores: '',
  });

  const [formMain, setFormMain] = useState({
    usuarioId: userID,
    tipoTermo: '',
    nomeTermo: '',
    descricao: '',
    sinonimos: '',
    afeicoes: '',
    maisInformacoes: '',
    observacoes: '',
  });

  //Buscar dados
  const fetchData = async (id: string) => {
    try {
      const registroData = await getGlossario(id);
      setLogData(registroData);
      setFormMain({
        usuarioId: userID,
        tipoTermo: registroData.tipoTermo,
        nomeTermo: registroData.nomeTermo,
        descricao: registroData.descricao,
        sinonimos: registroData.sinonimos,
        afeicoes: registroData.afeicoes,
        maisInformacoes: registroData.maisInformacoes,
        observacoes: registroData.observacoes,
      });
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  //Condicional para verificar se é necessário buscar dados e ajustar subabas
  if (fichaID !== 'undefined') {
    //Buscar dados
    useEffect(() => {
      fetchData(fichaID); // Chama a função para buscar dados quando o comp
    }, []);
    logs = {
      id: logData.id,
      usuarioRegistro: formataNomeMeioSiglas(
        logData.usuarioRegistro.nomeCompleto,
      ),
      usuarioAtualizacao: formataNomeMeioSiglas(
        logData.usuarioAtualizacao.nomeCompleto,
      ),
      dataRegistro: logData.dataRegistro,
      dataAtualizacao: logData.dataUltimaAtualizacao,
      nEdicoes: logData.nEdicoes,
    };

    //Subabas
    subAbas = SubAbasGlossario(fichaID);
  } else {
    subAbas = [
      {
        label: 'Dados Gerais',
        rota: `/daf/home/glossario/ficha/dadosgerais`,
      },
    ];
  }

  //Funções Handle
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;

    setFormMain((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = (form: any) => {
    const errors: string[] = [];

    // Verificar cada campo
    if (!form.tipoTermo) {
      errors.push('<b>Tipo de Termo</b> é obrigatório.');
    }

    if (!form.nomeTermo) {
      errors.push('<b>Nome do Termo</b> é obrigatório.');
    }

    if (!form.descricao) {
      errors.push('<b>Descrição</b> é obrigatório.');
    }

    if (errors.length > 0) {
      swalErro(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const handleCreate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formMain);
      if (!isFormValid) return;

      // Criar uma cópia de formMain
      const { ...formToSend } = {
        ...formMain,
        tipoTermo: Number(formMain.tipoTermo),
      };

      // const token = 'JWT_SECRET';

      const response = await httpClient.post(`/api/glossario/`, formToSend);

      swalSave();
      setTimeout(
        () =>
          (window.location.href = `#/daf/home/glossario/ficha/${response.data.registro.id}/dadosgerais`),
        2500,
      );
    } catch (error) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      swal('error', 'Erro!', 'Erro ao salvar registro.');
    }
  };

  const handleUpdate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formMain);
      if (!isFormValid) return;

      // Criar uma cópia de formMain
      const { ...formToSend } = {
        ...formMain,
        tipoTermo: Number(formMain.tipoTermo),
      };

      const response = await httpClient.patch(
        `/api/glossario/${fichaID}`,
        formToSend,
      );

      swalAtualizacao('Sucesso', response.data.message);
      fetchData(response.data.registro.id);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
      console.log(error.message);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) {
      return;
    }

    if (result) {
      try {
        await httpClient.delete(`/api/glossario/${fichaID}`);
        swalDeleteConfirm();
        navigate('/daf/home/glossario');
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    } else {
      swalErro('A operação falhou.');
    }
  };

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/home/glossario"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          <Log {...logs} />

          <BoxConteudo boxTitulo="Dados da Versão">
            <CustomRow
              style={{ marginTop: '-15px', justifyContent: 'flex-start' }}
            >
              <CustomCol width="200px">
                <SelectInput
                  name="tipoTermo"
                  options={tipoTermo}
                  label="Tipo de Termo"
                  value={formMain.tipoTermo}
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="nomeTermo"
                  label="Termo"
                  value={formMain.nomeTermo}
                  id="nomeTermo"
                  onChange={handleChange}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <Input
                  name="sinonimos"
                  label="Sinônimos"
                  value={
                    formMain.sinonimos ? formMain.sinonimos : 'Não informado'
                  }
                  id="sinonimos"
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="afeicoes"
                  label="Afeições (outros termos que possuem relação com este)"
                  value={
                    formMain.afeicoes ? formMain.afeicoes : 'Não informado'
                  }
                  id="afeicoes"
                  onChange={handleChange}
                />
              </CustomCol>
            </CustomRow>

            {/* Descrição */}
            <CustomRow>
              <CustomCol>
                <Input
                  name="descricao"
                  label="Descrição"
                  value={formMain.descricao}
                  id="descricao"
                  onChange={handleChange}
                  type="textarea"
                  linhas={10}
                />
              </CustomCol>
            </CustomRow>

            <CustomRow>
              <CustomCol>
                <Input
                  name="maisInformacoes"
                  label="Mais informações"
                  value={formMain.maisInformacoes || 'Não informado'}
                  id="maisInformacoes"
                  onChange={handleChange}
                  style={
                    formMain.maisInformacoes &&
                    formMain.maisInformacoes !== 'Não informado'
                      ? {
                          color: 'blue',
                          textDecoration: 'underline',
                          cursor: 'pointer',
                        }
                      : {}
                  }
                  onClick={() =>
                    formMain.maisInformacoes &&
                    formMain.maisInformacoes !== 'Não informado'
                      ? window.open(
                          formMain.maisInformacoes,
                          '_blank',
                          'noopener,noreferrer',
                        )
                      : null
                  }
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          {/* Observações */}
          <BoxConteudo boxTitulo="Observações" fechado>
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol>
                <Input
                  id="observacoes"
                  name="observacoes"
                  value={formMain.observacoes}
                  label=""
                  type="textarea"
                  onChange={handleChange}
                  linhas={5}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            onClickDelete={handleDelete}
            save
            onClickSave={handleUpdate}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={handleCreate} />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
